import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import configureStore from './store';
import buildConfig from './util/buildConfig';

const appLayerWrapper = document.querySelector('[data-app-layer="main"]');
const config = buildConfig(appLayerWrapper.dataset);
export const store = configureStore(config);

const initAppLayer = () => {
  // Create a root and render
  const root = ReactDOM.createRoot(appLayerWrapper); // Using createRoot
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App config={{ ...config.config }} />
      </Provider>
    </React.StrictMode>
  );
};

initAppLayer();
